export type FileAccessCacheEntry = {
  accessUrl: string;
  accessUrlExpiresAt: string;
};

const REFRESH_BUFFER_MS = 5 * 60_000;

export class FileAccessCache {
  private readonly entries = new Map<string, FileAccessCacheEntry>();

  get(uploadId: string): FileAccessCacheEntry | undefined {
    const entry = this.entries.get(uploadId);
    if (!entry) {
      return undefined;
    }
    if (Date.parse(entry.accessUrlExpiresAt) <= Date.now() + REFRESH_BUFFER_MS) {
      this.entries.delete(uploadId);
      return undefined;
    }
    return entry;
  }

  set(uploadId: string, entry: FileAccessCacheEntry): void {
    this.entries.set(uploadId, entry);
  }

  setMany(urls: Array<{ uploadId: string; accessUrl: string; accessUrlExpiresAt: string }>): void {
    for (const item of urls) {
      this.set(item.uploadId, {
        accessUrl: item.accessUrl,
        accessUrlExpiresAt: item.accessUrlExpiresAt,
      });
    }
  }

  missingUploadIds(uploadIds: string[]): string[] {
    return uploadIds.filter((id) => !this.get(id));
  }
}

export function collectUploadIdsFromMessageParts(
  parts: Array<{ type?: string; uploadId?: string }>,
): string[] {
  const ids: string[] = [];
  for (const part of parts) {
    if (part.type === "file" && typeof part.uploadId === "string" && part.uploadId) {
      ids.push(part.uploadId);
    }
  }
  return ids;
}

export function collectUploadIdsFromMessages(
  messages: Array<{ parts?: Array<{ type?: string; uploadId?: string }>; parentMessage?: { parts?: Array<{ type?: string; uploadId?: string }> } }>,
): string[] {
  const ids = new Set<string>();
  for (const message of messages) {
    for (const uploadId of collectUploadIdsFromMessageParts(message.parts ?? [])) {
      ids.add(uploadId);
    }
    for (const uploadId of collectUploadIdsFromMessageParts(message.parentMessage?.parts ?? [])) {
      ids.add(uploadId);
    }
  }
  return [...ids];
}
